// extracted by mini-css-extract-plugin
export var angle = "featuredVideo-module--angle--fafa2";
export var coverImage = "featuredVideo-module--coverImage--d61d9";
export var coverImageWrapper = "featuredVideo-module--coverImageWrapper--ba476";
export var featuredVideo = "featuredVideo-module--featuredVideo--50e22";
export var featuredVideoWrapper = "featuredVideo-module--featuredVideoWrapper--17e4d";
export var modalContentWrapper = "featuredVideo-module--modalContentWrapper--a755d";
export var modalTitle = "featuredVideo-module--modalTitle--d74b5";
export var play = "featuredVideo-module--play--6094d";
export var slideUp = "featuredVideo-module--slideUp--22916";
export var slideUpLarge = "featuredVideo-module--slideUpLarge--33e70";
export var title = "featuredVideo-module--title--feda0";
export var videoWrapper = "featuredVideo-module--videoWrapper--bdc52";